export enum PersonLanguageEnum {
  "NL" = 0,
  "FR" = 1,
}
